import styled from 'styled-components'
import { PrimaryButton } from '../../../shared/Buttons/Buttons.styles'

export const SignUpBannerImage = styled.section`
  text-align: center;
  // margin-top: 4.8rem;

  @media screen and (min-width: ${props => props.theme.responsive.medium}) {
    // margin-top: 6.4rem;
  }

  &:last-child {
    margin-bottom: 0 !important;
  }

  .wrapper {
    position: relative;
    padding: 5.6rem 0;
    background-size: cover;
    min-height: 27rem;
    overflow: hidden;
    background-color: black;
    color: white;

    section {
      margin-bottom: 0;
    }

    @media screen and (min-width: ${props => props.theme.responsive.small}) {
      padding: 8rem 0;
    }

    @media screen and (min-width: ${props => props.theme.responsive.medium}) {
      max-height: 56rem;
    }

    &.videoContent {
      padding: 0;

      @media screen and (min-width: ${props => props.theme.responsive.medium}) {
        height: 56vh;
        background-position: center center;
      }

      @media screen and (max-width: ${props => props.theme.responsive.small}) {
        background-position: top left 65%;
        background-size: 200%;
      }
      /* // Leaving here incase adjustment is needed
      @media screen and (min-width: ${props =>
    props.theme.responsive.small}) and (max-width: ${props =>
  props.theme.responsive.medium}) {
        background-position: top left 25%;
        background-size: 200%;
      } */

      .videoPoster {
        height: 100%;
        width: auto;
        display: none;

        @media screen and (min-width: ${props =>
    props.theme.responsive.medium}) {
          min-width: 100%;
          min-height: 100%;
          max-width: none;
          display: none;
        }
      }
    }
    .content {
      color: ${props => props.theme.colors.white};
      position: absolute;
      width: 100%;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      svg {
        width: 4.78rem;
        fill: ${props => props.theme.colors.white};
      }
      @media screen and (min-width: ${props => props.theme.responsive.small}) {
        svg {
          width: 8rem;
          transition: transform 0.25s;
          cursor: pointer;
          &:hover {
            transform: scale(1.05);
          }
        }
      }

      h4 {
        display: inline-block;
        &:after {
          margin: auto;
          content: '';
          display: block;
          height: 2px;
          max-width: 12.5rem;
          background-color: ${props => props.theme.colors.white};
          @media screen and (min-width: ${props =>
    props.theme.responsive.small}) {
            max-width: 32rem;
          }
        }
      }
    }

    h4 {
      margin-bottom: 1.5rem;
    }
    p {
      margin-bottom: 2.4rem;
    }
    button {
      padding: 1.2rem 3rem;
      display: block;
      font-size: 1.4rem;
      border-color: white;
      color: white;

      &:after {
        top: 1.1rem;
        background-size: 100%;
      }

      @media screen and (min-width: ${props => props.theme.responsive.small}) {
        font-size: 1.6rem;
        padding: 1.7rem 1.6rem;
        display: inline-block;
        min-width: 25.6rem;
      }
    }
  }
`

export const StyledPopup = styled.div`
  background: #ececec;
  min-height: 500px;
  width: 100%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  box-shadow: 0 0 30px 0 rgb(0 0 0 / 30%);
  overflow: auto;
  padding: 3rem 5rem;
  max-width: 540px;
  max-height: calc(100vh - 100px);
`

export const StyledSubmit = styled(PrimaryButton)`
  font-size: 1.6rem;
  margin-top: 2rem;

  button {
    width: 100%;
    margin: 0 auto;
    font-size: 1.6rem;
    padding: 1.6rem;
    max-width: none;

    @media screen and (min-width: ${props => props.theme.responsive.small}) {
      width: 35.7rem;
      margin: 0 auto;
      font-size: 2.4rem;
      padding: 2.5rem 1.6rem;

      svg {
        margin-top: 0.4rem;
      }
    }
  }

  @media screen and (min-width: ${props => props.theme.responsive.small}) {
    font-size: 2.4rem;
    margin-top: 2rem;
  }
`
